import React, { useEffect, useRef } from 'react';
import { useLocation } from 'react-router-dom';
import { InnerRoutes } from '../../navigation/routes';

const MainFrame = (): JSX.Element => {
  const location = useLocation();
  const scrollContainerRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    scrollContainerRef.current?.scrollTo({ top: 0, left: 0 });
  }, [location]);

  return (
    <div className="flex-grow overflow-x-hidden overflow-y-auto" ref={scrollContainerRef}>
      <InnerRoutes />
    </div>
  );
};

export default MainFrame;
